@if ((product$ | async) || product; as product) {
  @for (campaign of product.campaignsTypes; track campaign) {
    <section class="campaign-note__section">
      <p [innerHTML]="campaign.note"></p>
    </section>
  }
}
